import { render, staticRenderFns } from "./TableSubjects.vue?vue&type=template&id=0a10f4ba&"
import script from "./TableSubjects.vue?vue&type=script&lang=js&"
export * from "./TableSubjects.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src1477836768/src/github.com/FebosIO/Febos-AMI/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0a10f4ba')) {
      api.createRecord('0a10f4ba', component.options)
    } else {
      api.reload('0a10f4ba', component.options)
    }
    module.hot.accept("./TableSubjects.vue?vue&type=template&id=0a10f4ba&", function () {
      api.rerender('0a10f4ba', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/febos/chile/dnt/components/wizard/companies/60100003-2/components/TableSubjects.vue"
export default component.exports